import React, { useRef, useState, useEffect } from 'react';
import {
    Grid,
    MenuItem,
    TextField,
    Typography,
    InputLabel,
    Box,
    Card,
    Select,
    Icon,
    Link,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SimpleFooter from "examples/Footers/SimpleFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";
import Breadcrumbs from "examples/Breadcrumbs";
import Autocomplete from '@mui/material/Autocomplete';
import MKInput from 'components/MKInput';
import SearchIcon from "@mui/icons-material/Search";
import AWS from 'aws-sdk';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from "@mui/material/Modal";
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';
import { LocationOn } from '@mui/icons-material';
import Logo from "assets/images/skill2.png";
import CompanyIcon from "assets/images/companyicon.png";
import Expectation from "assets/images/team_3082743.png";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { getAllISOCodes, getAllInfoByISO } from 'iso-country-currency';
import DatePicker from "react-multi-date-picker";
import Slider from '@mui/material/Slider';
import editRoutes from "trainerEditRoutes";
import MKAlert from "components/MKAlert";
import VirtualIcon from "assets/images/virtual.png";
import ClassroomIcon from "assets/images/classroom.png";
import { useNavigate } from 'react-router-dom';
import defaultRoutes from "routes";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import '../../../styles.css';

const LoadingOverlay = ({ loading, children }) => {
    return (
        <>
            {loading && (
                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        filter: 'blur(5px)',
                        pointerEvents: 'none',
                    }}
                    open={loading}
                >
                    <Box
                        sx={{
                            height: 'auto',
                            p: 2,
                            mx: { xs: 2, lg: 3 },
                            mt: -8,
                            mb: 4,
                            backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                            backdropFilter: "saturate(200%) blur(30px)",
                            boxShadow: ({ boxShadows: { xxl } }) => xxl,
                            position: "absolute",
                            top: "0",
                            left: "0",
                            zIndex: "1",
                            width: "100%",
                            minHeight: "100vh",
                            // display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            userSelect: 'none',
                        }}
                    >
                        {children}
                    </Box>
                </Backdrop>
            )}
            {loading && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: (theme) => theme.zIndex.drawer + 2,
                    }}
                >
                    <CircularProgress />
                </Box>
            )}
            {!loading && children}
        </>
    );
};

function valuetext(value) {
    return `${value}`;
}

function CustomMultipleInput({ openCalendar, value }) {
    return (
        <React.Fragment>
            <input type="hidden"
                onFocus={openCalendar}
                value={value}
                readOnly
            />
            <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: "20px" }} onClick={openCalendar}>Select Dates</MKButton>
        </React.Fragment>
    );
}

const sidebarStyles = {
    width: '350px',
    padding: '20px',
    color: 'white',
    borderRadius: '15px',
};

const Page = () => {
    // const styles = {
    //     gridItem: {
    //         border: '1px double #ccc',
    //         borderRadius: '30px',
    //         padding: '16px',
    //         marginBottom: '30px',
    //         boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    //         width: '1000px',
    //         backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 1.5), backdropFilter: "saturate(200%) blur(30px)", boxShadow: ({ boxShadows: { xxl } }) => xxl,
    //     },
    //     trainingInfo: {
    //         display: 'flex',
    //         flexDirection: 'column',
    //     },
    //     trainingName: {
    //         marginTop: '-10px',
    //         marginBottom: '8px',
    //         fontSize: 'medium',
    //         color: 'rgb(60, 150, 190)'
    //     },
    //     gridContent: {
    //         padding: '13px',
    //     },
    // };

    const [modeOfTraining, setModeOfTraining] = useState("");
    const [classroomLocation, setClassroomLocation] = useState("");
    const [budget, setBudget] = useState("");
    const [budgetSliderValue, setBudgetSliderValue] = useState([0, 100000]);
    const [budgetRangeFrom, setBudgetRangeFrom] = useState(0);
    const [budgetRangeTo, setBudgetRangeTo] = useState(100000);
    const [commercialsLessThan4hrs, setCommercialsLessThan4hrs] = useState("");
    const [commercials4hrs, setCommercials4hrs] = useState("");
    const [commercials8hrs, setCommercials8hrs] = useState("");
    const [commercialsCurrency, setCommercialsCurrency] = useState("");
    const [lab, setLab] = useState("");
    const [labCostPerParticipants, setLabCostPerParticipants] = useState("");
    const [currentTotalPages, setCurrentTotalPages] = useState(1);
    const [serverCount, setServerCount] = useState("");
    const [typeOfServer, setTypeOfServer] = useState("");
    const [courseDuration, setCourseDuration] = useState("");
    const [lastClient, setLastClient] = useState("");
    const [trainingComment, settrainingComment] = useState("");
    const [lastDeliveredDate, setLastDeliveredDate] = useState("");
    const [trainingAvailableDate, setTrainingAvailableDate] = useState([]);
    const [callAvailableDate, setCallAvailableDate] = useState([]);
    const [trainerProfile, setTrainerProfile] = useState("");
    const [selectedTrainingCompanyId, setSelectedTrainingCompanyId] = useState("");
    const [selectedTrainingName, setSelectedTrainingName] = useState("");
    const [selectedTrainingID, setSelectedTrainingID] = useState("");
    const [showLocationField, setShowLocationField] = useState(false);
    const [skillsName, setSkillsName] = useState([]);
    const [trainerDetails, setTrainerDetails] = useState([]);
    const [userId, setUserId] = useState("");
    const [trainingList, setTrainingList] = useState([]);
    const [bbdata, setbbData] = useState([]);
    const [submitCompleted, setSubmitCompleted] = useState(false);
    const [tocAvailable, setTocAvailable] = useState("");
    const [proposalState, setProposalState] = useState("");
    const [trainingType, setTrainingType] = useState("");
    const [trainingTiming, setTrainingTiming] = useState("");
    const [audienceLevel, setAudienceLevel] = useState("");
    const [trainingExpectation, setTrainingExpectation] = useState("");
    const [participantsSliderValue, setParticipantsSliderValue] = useState([0, 100]);
    const [minParticipants, setMinParticipants] = useState(0);
    const [maxParticipants, setMaxParticipants] = useState(100);
    const [durationSliderValue, setDurationSliderValue] = useState([0, 100]);
    const [fromDuration, setFromDuration] = useState(0);
    const [toDuration, setToDuration] = useState(100);
    const [timeZone, setTimeZone] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [currency, setCurrency] = useState('');
    const [selectedCurrencyCountry, setSelectedCurrencyCountry] = useState('');
    const [toc, setToc] = useState('');
    const [s3BucketURL, setS3BucketURL] = useState('');
    const pageSize = 5;
    const [currentPage, setCurrentPage] = useState(1);

    const [trainerProfileCreate, setTrainerProfileCreate] = useState(false);
    const [emailVerified, setEmailVerified] = useState(false);
    const [mobVerified, setMobVerified] = useState(false);
    const [tcVerified, setTcVerified] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [maxApplyCount, setMaxApplyCount] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleBudgetSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setBudgetRangeFrom(minValue);
        setBudgetRangeTo(maxValue);
        setBudgetSliderValue(newValues);
    };

    const handleSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setMinParticipants(minValue);
        setMaxParticipants(maxValue);
        setParticipantsSliderValue(newValues);
    };

    console.log("minParticipants", minParticipants);
    console.log("maxParticipants", maxParticipants);

    const handleDurationSliderChange = (event, newValues) => {
        const [minValue, maxValue] = newValues;
        setFromDuration(minValue);
        setToDuration(maxValue);
        setDurationSliderValue(newValues);
    };

    const timeZones = moment.tz.names();

    const handleTimeZoneChange = (newValue) => {
        setTimeZone(newValue);
    };
    console.log("timeZone", timeZone);

    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };
    console.log("fromDate", fromDate);

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };
    console.log("toDate", toDate);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    let initialSearchValue = queryParams.get('search');
    const asearch = queryParams.get('search');
    const amodeOfTraining = queryParams.get('modeOfTraining');
    const aclassroomLocation = queryParams.get('classroomLocation');
    console.log("hi");
    console.log("search", asearch);
    console.log("modeOfTraining", amodeOfTraining);
    console.log("classroomLocation", aclassroomLocation);

    const [search, setSearch] = useState(initialSearchValue || '');

    useEffect(() => {
        let technology = search === "ANY" ? "" : search;
        const apiUrl = localStorage.getItem("userId")
            ? `${process.env.REACT_APP_API_URL}/api/getSearchtech-training/${localStorage.getItem("userId")}/${technology}`
            : `${process.env.REACT_APP_API_URL}/api/getSearchtech-training/${technology}`;
        console.log("apiUrl", apiUrl);

        fetch(`${apiUrl}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail) {
                    setbbData(data);
                    setTrainingList(data.results || data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [search]);

    console.log("skillsName", skillsName);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.detail) {
                } else {
                    setSkillsName(["ANY", ...data]);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);
    console.log("skillsName", skillsName);

    useEffect(() => {
        let id = localStorage.getItem("userId");
        setUserId(id);
        if (id) {
            fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-list/${id}/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.detail) {
                    } else {
                        setTrainerDetails(data);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, []);
    console.log("trainerDetails", trainerDetails);

    const onSubmitClick = async () => {
        const filteredList = filterTrainingList();
        setTrainingList(filteredList);
    };

    useEffect(() => {
        const id = localStorage.getItem("userId");
        console.log(id);
        setUserId(id);

        if (id) {
            fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.detail) {
                    } else {
                        setEmailVerified(data.is_verified);
                        setMobVerified(data.is_verified_mobile);
                        setTcVerified(data.is_verified_tc);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [localStorage.getItem("token")]);

    useEffect(() => {
        const id = localStorage.getItem("userId");

        if (id) {
            fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofileuidexists/${id}/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.exists === false) {
                        setTrainerProfileCreate(true);
                        window.location.href = "/app/trainerprofile";
                    } else {
                        setTrainerProfileCreate(false);
                    }
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        }
    }, [localStorage.getItem("userId")]);

    console.log("trainingList", trainingList);
    console.log("data", bbdata);

    const totalPages = Math.ceil(trainingList.length / pageSize);

    useEffect(() => {
        if (asearch !== search) {
            setSearch(asearch);
        }

        if (amodeOfTraining !== modeOfTraining) {
            setModeOfTraining(amodeOfTraining);
        }

        if (aclassroomLocation !== classroomLocation) {
            setClassroomLocation(aclassroomLocation);
        }
    }, [asearch, amodeOfTraining, aclassroomLocation]);

    const onClearFilterClick = () => {
        setSearch("");
        setBudget("");
        setBudgetRangeFrom("");
        setBudgetRangeTo("");
        setModeOfTraining("");
        setClassroomLocation("");
        setShowLocationField(false);
        setTocAvailable("");
        setFromDate("");
        setToDate("");
        setFromDuration("");
        setToDuration("");
        setProposalState("");
        setMinParticipants("");
        setMaxParticipants("");
        setTrainingTiming("");
        setTimeZone("");
        setTrainingType("");
        setAudienceLevel("");
        setTrainingExpectation("");
        initialSearchValue = "";
    };

    const onApplyClick = (training) => {
        setLoading(true);
        setMaxApplyCount(false);
        let id = localStorage.getItem("userId");
        console.log("userId", id);
        let name = training.trainingName;
        let trainingId = training.id.toString();
        setSelectedTrainingName(name);
        setSelectedTrainingID(trainingId);
        let companyID = training.trainingCompanyUserID;
        setSelectedTrainingCompanyId(companyID);
        let permiumStatus = trainerDetails.premiumStatus;

        fetch(`${process.env.REACT_APP_API_URL}/api/single-training-details/${trainingId}/${id}/${permiumStatus}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail && data.message === "User not found") {
                    console.log("details", data.message);
                    setShowModal(true);
                    setLoading(false);
                } else if (data.message === "Remainder reached maximum for the day") {
                    setMaxApplyCount(true);
                    setLoading(false);
                } else {
                    console.log("data inside1111111", data);
                    setShowModal(true);
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    console.log("selectedTrainingName", selectedTrainingName);
    console.log("selectedTrainingID", selectedTrainingID);
    console.log("selectedTrainingCompanyId", selectedTrainingCompanyId);

    const onCloseApplyClick = () => {
        setLoading(false);
        setShowModal(false);
        setCommercialsLessThan4hrs("");
        setCommercials4hrs("");
        setCommercials8hrs("");
        setLab("");
        setServerCount("");
        setTypeOfServer("");
        setLabCostPerParticipants("");
        setTrainingAvailableDate("");
        setCallAvailableDate("");
        setCourseDuration("");
        setLastDeliveredDate("");
        setLastClient("");
        settrainingComment("");
        setTrainerProfile("");
        setSelectedCurrencyCountry("");
        setCurrency("");
        setToc(null);
        setSelectionToc("");
    };

    const handleCountryCurrencyChange = (event) => {
        const selectedISO = event.target.value;
        setSelectedCurrencyCountry(selectedISO);

        const currencyInfo = getAllInfoByISO(selectedISO);
        setCurrency(`${currencyInfo.currency} (${currencyInfo.symbol})`);
    };

    console.log("currency", currency);

    const handleSearchChange = (event, value) => {
        setSearch(value);
        const typedSkill = event.target.value;
        console.log("typedSkill@@@@@@@@@@@@@", typedSkill);
        if (typedSkill && !skillsName.includes(typedSkill)) {
            fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/?q=${typedSkill}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    setSkillsName([...skillsName, ...data]);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };
    console.log("search", search);
    console.log("commercialsLessThan4hrs", commercialsLessThan4hrs);
    console.log("commercials4hrs", commercials4hrs);
    console.log("commercials8hrs", commercials8hrs);
    console.log("serverCount", serverCount);
    console.log("typeOfServer", typeOfServer);
    console.log("labCostPerParticipants", labCostPerParticipants);
    console.log("courseDuration", courseDuration);
    console.log("lastClient", lastClient);
    console.log("trainingComment", trainingComment);

    const today = new Date().toISOString().split('T')[0];
    const handleLastDeliveredDateChange = (e) => {
        setLastDeliveredDate(e.target.value);
    };
    console.log("lastDeliveredDate", lastDeliveredDate);

    const handleTrainingAvailableChange = (selectedDates) => {
        const formattedDates = selectedDates.map((date) => {
            return date.format('YYYY-MM-DD');
        });

        setTrainingAvailableDate(formattedDates);
    };

    console.log("trainingAvailableDate", trainingAvailableDate);

    const handleCallAvailableDateChange = (selectedDates) => {
        const formattedDates = selectedDates.map((date) => {
            return date.format('YYYY-MM-DD');
        });

        setCallAvailableDate(formattedDates);
    };
    console.log("callAvailableDate", callAvailableDate);

    console.log("budget", budget);
    console.log("budgetRangeFrom", budgetRangeFrom);
    console.log("budgetRangeTo", budgetRangeTo);

    const handlePreferredModeChange = (e) => {
        const selectedMode = e.target.value;
        setModeOfTraining(selectedMode);

        if (selectedMode === "Classroom") {
            setShowLocationField(true);
        } else {
            setShowLocationField(false);
        }
    };
    console.log("modeOfTraining", modeOfTraining);
    console.log("showLocationField", showLocationField);

    useEffect(() => {
        let id = localStorage.getItem("userId");
        setUserId(id);
    }, []);

    const tocFileInputRef = useRef(null);

    AWS.config.update({
        accessKeyId: process.env.REACT_APP_S3_AWS_ACCESS_KEY,
        secretAccessKey: process.env.REACT_APP_S3_AWS_SECRET_ACCESS_KEY,
        region: process.env.REACT_APP_S3_REGION,
    });

    useEffect(() => {
        let userName = localStorage.getItem("user");
        let id = localStorage.getItem("userId");
        let bucketURL = `trainerhub/${id}_${userName}`;
        setS3BucketURL(bucketURL);
    }, [])

    const [selectionToc, setSelectionToc] = useState("");

    const handleTocChange = (e) => {
        setSelectionToc(e.target.value);
    };

    const [tocError, setTocError] = useState(null);

    const handleUploadClick = () => {
        tocFileInputRef.current.click();
    };

    const handleTocUploadChange = (event) => {
        const selectedFile = event.target.files[0];
        const fileExtension = selectedFile.name.split('.').pop();

        if (selectedFile) {
            const allowedFormats = ['pdf', 'docx', 'xlsx', 'xls'];

            if (!allowedFormats.includes(fileExtension.toLowerCase())) {
                setTocError("Please check the file format.");
                return;
            }

            if (selectedFile.size > 5 * 1024 * 1024) {
                setTocError("File size should be maximum 5mb.");
                return;
            }

            setTocError(null);
            const renamedFile = new File([selectedFile], `${selectedTrainingName}_${selectedTrainingID}_toc.${fileExtension}`, { type: selectedFile.type });
            setToc(renamedFile);
        }
    };

    console.log("toc", toc);
    const onSaveApplyClick = async (e) => {
        setLoading(true);
        try {
            const data = {
                appliedTrainerID: userId,
                selectedTrainingID: selectedTrainingID,
                selectedTrainingName: selectedTrainingName,
                trainingCompanyUserID: selectedTrainingCompanyId,
                profileName: trainerProfile,
                applyToc: selectionToc,
                tocURL: s3BucketURL,
                currency: commercialsCurrency,
                commercialsForLessThan4hrs: commercialsLessThan4hrs,
                commercialsFor4hrs: commercials4hrs,
                commercialsFor8hrs: commercials8hrs,
                labsByTrainer: lab,
                serverCount: serverCount,
                typeOfServer: typeOfServer,
                labCostPerParticipants: labCostPerParticipants,
                availableDatesForTraining: trainingAvailableDate,
                availableDatesForCall: callAvailableDate,
                courseDurationHRS: courseDuration,
                recentLastDeliveredDate: lastDeliveredDate,
                recentLastDeliveredClient: lastClient,
                comments: trainingComment,
                premiumStatus: trainerDetails.premiumStatus,
                applyTrainingStatus: "1",
            };
            console.log(JSON.stringify(data));
            setLoading(true);
            setShowModal(false);

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/apply-training/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
                body: JSON.stringify(data),
            });

            if (response.ok && toc) {
                const formData = new FormData();
                formData.append('files', toc);

                console.log("formData", formData);
                console.log("s3BucketURL", s3BucketURL);

                fetch(`${process.env.REACT_APP_API_URL}/api/upload/${s3BucketURL}/applytraining/`, {
                    method: 'POST',
                    body: formData,
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log(data);
                    })
                    .catch(error => {
                        console.error('Error uploading file:', error);
                    });
                console.log("Toc uploaded successfully");
                setShowModal(false);
                setSubmitCompleted(true);
                setLoading(false);
            } else if (response.ok && !toc) {
                setShowModal(false);
                setSubmitCompleted(true);
                setLoading(false);
            } else {
                setSubmitCompleted(false);
                throw new Error("Profile is not created. Something went wrong");
            }
            setShowModal(false);
            setSubmitCompleted(true);
            setLoading(false);
        } catch (error) {
            console.log("Error:", error.message);
            setSubmitCompleted(false);
        }
    };

    const DialogProfileClose = () => {
        setShowModal(false);
        setLoading(false);
        window.location.href = "/app/traininglist";
    };

    const handleTrainingProfileChange = (e) => {
        const selectedProfile = e.target.value;
        setTrainerProfile(selectedProfile);

        const experienceArray = trainerDetails.trainingExperience;

        const selectedExperience = experienceArray.find(
            (experience) => experience.profileName === selectedProfile
        );

        if (selectedExperience) {
            setCommercialsLessThan4hrs(selectedExperience.forLessThan4hrs || "");
            setCommercials4hrs(selectedExperience.for4hrs || "");
            setCommercials8hrs(selectedExperience.for8hrs || "");
            setCommercialsCurrency(selectedExperience.commercialsCurrency || "");
            setLastDeliveredDate(selectedExperience.dateOfLastTraining || "");
            setLastClient(selectedExperience.clientDelivered || "");
            setSelectedCurrencyCountry(selectedExperience.selectedCommercialsCurrency || "");
            setCourseDuration(selectedExperience.trainingDuration || "");
        }
    };


    const filterTrainingList = () => {
        return trainingList.filter((training) => {
            const tocAvailableMatch = !tocAvailable || training.tocAvailable === tocAvailable;
            const trainingLocationsMatch = !classroomLocation || training.trainingLocations === classroomLocation;
            const modeOfTrainingMatch = !modeOfTraining || training.trainingMode === modeOfTraining;
            const proposalStateMatch = !proposalState || training.trainingProposalState === proposalState;
            const trainingTypeMatch = !trainingType || training.trainingType === trainingType;
            const trainingTimingMatch = !trainingTiming || training.trainingTiming === trainingTiming;
            const audienceLevelMatch = !audienceLevel || training.audienceLevel === audienceLevel;
            const trainingExpectationMatch = !trainingExpectation || training.trainingExpectation === trainingExpectation;
            const minParticipantsMatch = !minParticipants || training.totalParticipants >= minParticipants;
            const maxParticipantsMatch = !maxParticipants || training.totalParticipants <= maxParticipants;
            const fromDurationMatch = !fromDuration || training.duration >= fromDuration;
            const toDurationMatch = !toDuration || training.duration <= toDuration;
            const budgetRangeFromMatch = !budgetRangeFrom || training.totalTrainingBudget >= budgetRangeFrom;
            const budgetRangeToMatch = !budgetRangeTo || training.totalTrainingBudget <= budgetRangeTo;
            const fromDateMatch = !fromDate || training.expectedStartDate >= fromDate;
            const toDateMatch = !toDate || training.expectedStartDate <= toDate;
            const timeZoneMatch = !timeZone || training.timeZone.includes(timeZone);

            return (
                tocAvailableMatch &&
                proposalStateMatch &&
                trainingTypeMatch &&
                trainingTimingMatch &&
                audienceLevelMatch &&
                trainingExpectationMatch &&
                modeOfTrainingMatch &&
                trainingLocationsMatch &&
                minParticipantsMatch &&
                maxParticipantsMatch &&
                fromDurationMatch &&
                toDurationMatch &&
                fromDateMatch &&
                toDateMatch &&
                budgetRangeFromMatch &&
                budgetRangeToMatch &&
                timeZoneMatch
            );
        });
    };

    console.log("trainerProfile", trainerProfile);

    const getCurrentPageData = () => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return filterTrainingList().slice(startIndex, endIndex);
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filterTrainingList().length / pageSize);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    useEffect(() => {
        const totalPages = Math.ceil(filterTrainingList().length / pageSize);
        setCurrentTotalPages(totalPages);
    }, [filterTrainingList()]);

    useEffect(() => {
        const id = localStorage.getItem("userId");
        console.log(id);
        setUserId(id);

        if (id) {
            fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.detail) {
                    } else {
                        setEmailVerified(data.is_verified);
                        setMobVerified(data.is_verified_mobile);
                        setTcVerified(data.is_verified_tc);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [localStorage.getItem("token")]);

    useEffect(() => {
        const id = localStorage.getItem("userId");

        if (id) {
            fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofileuidexists/${id}/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.exists === false) {
                        setTrainerProfileCreate(true);
                        window.location.href = "/app/trainerprofile";
                    } else {
                        setTrainerProfileCreate(false);
                    }
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        }
    }, [localStorage.getItem("userId")]);
    console.log("trainerProfileCreate", trainerProfileCreate);

    const navigate = useNavigate();

    const onMoreDetailsClick = (training) => {
        console.log("training1111111", training);
        console.log("token111111111", localStorage.getItem("token"));
        if (localStorage.getItem("token") === "" || localStorage.getItem("token") === null) {
            console.log("helloooooooooooooo");
            navigate('/pages/authentication/trainersign-in', { state: { redirectUrl: `/app/trainingDetails/${training.id}/` } });
        } else {
            console.log("aaaaaaaaaaaaaaaaaaaaa");
            navigate(`/app/trainingDetails/${training.id}/`);
        }

    };

    return (
        <>
            <LoadingOverlay loading={loading}>
                <DefaultNavbar
                    routes={localStorage.getItem("userId") ? (trainerProfileCreate ? routes : editRoutes) : defaultRoutes}
                    sticky
                />
                <Card
                    sx={{
                        height: 'auto',
                        p: 2,
                        mx: { xs: 2, lg: 3 },
                        mt: -8,
                        mb: 4,
                        // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                        backdropFilter: "saturate(200%) blur(30px)",
                        boxShadow: ({ boxShadows: { xxl } }) => xxl,
                    }}
                >
                    <Dialog
                        open={submitCompleted}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            Fantastic news!
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Your application for the training has been successfully submitted. Get ready for an enriching experience ahead!
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <MKButton onClick={() => { setSubmitCompleted(false); DialogProfileClose(); }} variant="gradient" size="small" color="info" autoFocus>
                                OK
                            </MKButton>
                        </DialogActions>
                    </Dialog>
                    <Container maxWidth="sm">
                        <form>
                            <Modal open={showModal} onClose={() => onCloseApplyClick} sx={{ display: "grid", placeItems: "center" }}>
                                <MKBox
                                    position="relative"
                                    width="850px"
                                    display="flex"
                                    flexDirection="column"
                                    borderRadius="xl"
                                    bgColor="white"
                                    shadow="xl"
                                    sx={{
                                        overflowY: 'auto',
                                        maxHeight: '90vh',
                                    }}
                                >
                                    <div>
                                        <>
                                            <h2 style={{ whiteSpace: 'nowrap', marginLeft: '10px' }}>
                                                {selectedTrainingName ? selectedTrainingName : 'Default Training Name'}
                                            </h2>
                                            <Grid container spacing={2}>
                                                <Grid item xs={4} style={{ marginTop: "20px" }}>
                                                    <div>
                                                        <FormControl variant="outlined" style={{ width: '250px' }}>
                                                            <InputLabel style={{ marginLeft: "10px" }} id="select-trainingProfile-label">Select Your Training Profile *</InputLabel>
                                                            <Select
                                                                labelId="select-trainingProfile-label"
                                                                label="Select Your Training Profile *"
                                                                onChange={handleTrainingProfileChange}
                                                                value={trainerProfile}
                                                                style={{ minHeight: '44px', width: '250px', marginLeft: "10px" }}
                                                            >
                                                                {trainerDetails.trainingExperience && trainerDetails.trainingExperience.map((experience, index) => (
                                                                    <MenuItem key={index} value={experience.profileName}>
                                                                        {experience.profileName}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: "20px" }}>
                                                    <div>
                                                        <FormControl variant="outlined" style={{ width: '250px' }}>
                                                            <InputLabel id="country-currency" shrink={!!selectedCurrencyCountry}>Country *</InputLabel>
                                                            <Select
                                                                labelId="country-currency"
                                                                label="Country *"
                                                                // fullWidth
                                                                onChange={handleCountryCurrencyChange}
                                                                value={selectedCurrencyCountry}
                                                                style={{ minHeight: '44px' }}
                                                            >
                                                                {getAllISOCodes().map((country) => (
                                                                    <MenuItem key={country.iso} value={country.iso}>
                                                                        {country.countryName}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: "20px" }}>
                                                    <div>
                                                        <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
                                                            <span>Currency: {commercialsCurrency}</span>
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                                                    <Breadcrumbs
                                                        routes={[{ label: "Commercials per hour" }]}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={4} style={{ marginTop: "20px" }}>
                                                    <div>
                                                        <TextField
                                                            label="For less than 4 hours *"
                                                            variant="outlined"
                                                            style={{ width: '250px', marginLeft: "10px" }}
                                                            value={commercialsLessThan4hrs}
                                                            onChange={(e) => setCommercialsLessThan4hrs(e.target.value)}
                                                        />
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: "20px" }}>
                                                    <div>
                                                        <TextField
                                                            label="For 4 hours *"
                                                            variant="outlined"
                                                            style={{ width: '250px' }}
                                                            value={commercials4hrs}
                                                            onChange={(e) => setCommercials4hrs(e.target.value)}
                                                        />
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: "20px" }}>
                                                    <div>
                                                        <TextField
                                                            label="For 8 hours *"
                                                            variant="outlined"
                                                            style={{ width: '250px' }}
                                                            value={commercials8hrs}
                                                            onChange={(e) => setCommercials8hrs(e.target.value)}
                                                        />
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={4} style={{ marginTop: "30px" }}>
                                                    <div>
                                                        <InputLabel style={{ marginLeft: '10px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>
                                                            Last Delivered Date
                                                        </InputLabel>
                                                        <TextField
                                                            type="month"
                                                            id="lastDelivered_date"
                                                            value={lastDeliveredDate || ""}
                                                            onChange={handleLastDeliveredDateChange}
                                                            style={{ width: "250px", marginLeft: "10px" }}
                                                            InputProps={{
                                                                inputProps: {
                                                                    max: new Date().toISOString().split('T')[0].substring(0, 7),
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: "30px" }}>
                                                    <div>
                                                        <TextField
                                                            label="Last Delivered Client"
                                                            variant="outlined"
                                                            style={{ width: '250px' }}
                                                            value={lastClient}
                                                            onChange={(e) => setLastClient(e.target.value)}
                                                        />
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: "30px" }}>
                                                    <div>
                                                        <TextField
                                                            label="Training Duration (in hours) *"
                                                            variant="outlined"
                                                            style={{ width: '250px' }}
                                                            value={courseDuration}
                                                            onChange={(e) => setCourseDuration(e.target.value)}
                                                        />
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                                                    <Breadcrumbs
                                                        routes={[{ label: "Available Dates For Training" }]}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "10px" }}>
                                                    <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }}>
                                                        From When
                                                        <DatePicker
                                                            multiple
                                                            id="selectedDates"
                                                            style={{ marginLeft: '20px' }}
                                                            render={<CustomMultipleInput />}
                                                            onChange={handleTrainingAvailableChange}
                                                            value={trainingAvailableDate}
                                                            minDate={new Date()}
                                                        // maxDate={fbmaxDate}
                                                        />
                                                    </Typography>
                                                    {trainingAvailableDate.length > 0 && (
                                                        <Typography style={{ marginTop: '5px' }} variant="body2" fontWeight="regular">
                                                            <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }} component="span">
                                                                Selected Dates For Training:
                                                            </Typography>{' '}
                                                            {trainingAvailableDate.join(', ')}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={2}>
                                                <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                                                    <Breadcrumbs
                                                        routes={[{ label: "Available Dates For Calls" }]}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "10px" }}>
                                                    <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }}>
                                                        From When
                                                        <DatePicker
                                                            multiple
                                                            id="selectedDates"
                                                            style={{ marginLeft: '20px' }}
                                                            render={<CustomMultipleInput />}
                                                            onChange={handleCallAvailableDateChange}
                                                            value={callAvailableDate}
                                                            minDate={new Date()}
                                                        // maxDate={fbmaxDate}
                                                        />
                                                    </Typography>
                                                    {callAvailableDate.length > 0 && (
                                                        <Typography style={{ marginTop: '5px' }} variant="body2" fontWeight="regular">
                                                            <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }} component="span">
                                                                Selected Dates For Call:
                                                            </Typography>{' '}
                                                            {callAvailableDate.join(', ')}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                    <div>
                                                        <TextField
                                                            label="Note"
                                                            multiline
                                                            rows={4}
                                                            variant="outlined"
                                                            style={{ width: '530px', marginLeft: "10px" }}
                                                            value={trainingComment}
                                                            onChange={(e) => {
                                                                settrainingComment(e.target.value);
                                                            }}
                                                        />
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: "10px", marginLeft: "280px" }}>
                                                    <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
                                                        Is TOC available? *
                                                    </Typography>

                                                    <FormControl component="fieldset" style={{ marginLeft: '0px' }}>
                                                        <RadioGroup row aria-label="toc" name="selectionToc" value={selectionToc} onChange={handleTocChange}>
                                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                                                                <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                                                            </Box>
                                                        </RadioGroup>
                                                    </FormControl>
                                                    {selectionToc === 'yes' && (
                                                        <>
                                                            <MKTypography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
                                                                TOC format in .pdf, .docx, .xlsx, .xls
                                                            </MKTypography>
                                                            <input
                                                                type="file"
                                                                id="toc-upload"
                                                                accept="pdf/*"
                                                                style={{ display: 'none' }}
                                                                ref={tocFileInputRef}
                                                                onChange={handleTocUploadChange}
                                                            />
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <label htmlFor="toc-upload">
                                                                    <MKButton onClick={handleUploadClick} variant="gradient" color="info" size="small" style={{ whiteSpace: 'nowrap' }}>
                                                                        Upload TOC
                                                                    </MKButton>
                                                                </label>
                                                                {toc && (
                                                                    <div style={{ fontSize: '14px', marginLeft: "10px" }}>
                                                                        <span> {toc.name}</span>
                                                                    </div>
                                                                )}
                                                                {tocError && (
                                                                    <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                                                                        {tocError}
                                                                    </MKTypography>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <div style={{ display: 'flex', marginBottom: "20px", marginLeft: "10px" }}>
                                                <MKButton variant="gradient" color="info" size="small" onClick={onCloseApplyClick}>
                                                    Cancel
                                                </MKButton>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-50px", marginRight: "10px", marginBottom: "10px" }}>
                                                <MKButton variant="gradient" color="info" size="small" disabled={!trainerProfile || !selectedCurrencyCountry || !commercialsLessThan4hrs || !commercials4hrs || !commercials8hrs || !courseDuration || !selectionToc} onClick={onSaveApplyClick}>
                                                    Apply
                                                </MKButton>
                                            </div>
                                        </>
                                    </div>
                                </MKBox>
                            </Modal>
                            <Grid container style={{ marginTop: "130px" }} spacing={2}>
                                <Grid item xs={12} sm={3}>
                                    <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h2" color="text">
                                        <span style={{ color: 'black' }}>Search</span>{' '}
                                        <span style={{ color: '#2e1114' }}>Trainings</span>
                                    </MKTypography>
                                </Grid>
                            </Grid>
                            <Grid container style={{ marginTop: '20px' }} >
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <Typography variant="h5" style={{ color: 'black' }}>Search by Skills</Typography>
                                        <Autocomplete
                                            // multiple
                                            id="skills"
                                            options={skillsName}
                                            value={search}
                                            freeSolo
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Skill"
                                                    variant="standard"
                                                    style={{ marginTop: '10px' }}
                                                    // fullWidth
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <SearchIcon fontSize="medium" />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            onChange={(event, value) => handleSearchChange(event, value)}
                                        />
                                    </div>
                                </Grid>
                            </Grid>

                            <Container>
                                <Grid container>
                                    <Grid item xs={4} style={{ marginLeft: '-50px' }}>
                                        <div style={sidebarStyles}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="h5" style={{ color: 'black', marginLeft: '8px' }}>Filters</Typography>
                                                {/* <Link href="#" onClick={onClearFilterClick} style={{ marginLeft: '65px', textDecoration: 'underline', color: 'blue', cursor: 'pointer', fontSize: 'small' }}>
                                                    Clear Filters
                                                </Link> */}
                                                <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: '65px', whiteSpace: 'nowrap' }} onClick={onClearFilterClick} >Clear Filters</MKButton>
                                                <MKButton variant="gradient" color="info" size="small" style={{ marginRight: '10px' }} onClick={onSubmitClick} >Submit</MKButton>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" style={{ flex: 1 }}>
                                                    <InputLabel id="preferred-mode-label">Mode Of Training</InputLabel>
                                                    <Select
                                                        labelId="preferred-mode-label"
                                                        label="Mode Of Training"
                                                        // fullWidth
                                                        onChange={handlePreferredModeChange}
                                                        value={modeOfTraining}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="Virtual">Virtual</MenuItem>
                                                        <MenuItem value="Classroom">Classroom</MenuItem>
                                                    </Select>
                                                </FormControl>

                                            </div>
                                            {showLocationField === true && modeOfTraining === 'Classroom' && (
                                                <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                    <TextField
                                                        label="Location"
                                                        variant="outlined"
                                                        // fullWidth
                                                        style={{ flex: 1 }}
                                                        value={classroomLocation}
                                                        onChange={(e) => setClassroomLocation(e.target.value)}
                                                    />
                                                </div>
                                            )}
                                            <Typography style={{ marginLeft: '10px', marginRight: '20px', marginTop: '10px' }} variant="h6">Budget</Typography>
                                            <div style={{ marginLeft: '10px', marginTop: '10px', padding: '10px' }}>
                                                <Slider
                                                    value={budgetSliderValue}
                                                    onChange={handleBudgetSliderChange}
                                                    size="small"
                                                    getAriaValueText={valuetext}
                                                    valueLabelDisplay="auto"
                                                    aria-labelledby="range-slider"
                                                    max={100000}
                                                />
                                            </div>
                                            <div style={{ marginLeft: '10px', adding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <TextField
                                                    label="Min"
                                                    variant="outlined"
                                                    style={{ width: '100px' }}
                                                    // fullWidth
                                                    onChange={(e) => setBudgetRangeFrom(e.target.value)}
                                                    value={budgetRangeFrom}
                                                    InputProps={{ inputProps: { min: 1000, max: 100000 } }}
                                                    type="number"
                                                />
                                                <TextField
                                                    label="Max"
                                                    variant="outlined"
                                                    style={{ marginRight: '10px', width: '100px' }}
                                                    // fullWidth
                                                    onChange={(e) => setBudgetRangeTo(e.target.value)}
                                                    value={budgetRangeTo}
                                                    InputProps={{ inputProps: { min: 1000, max: 100000 } }}
                                                    type="number"
                                                />
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="toc-available-label">TOC Available</InputLabel>
                                                    <Select
                                                        labelId="toc-available-label"
                                                        label="TOC Available"
                                                        // fullWidth
                                                        onChange={(e) => setTocAvailable(e.target.value)}
                                                        value={tocAvailable}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="yes">Yes</MenuItem>
                                                        <MenuItem value="no">No</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="proposal-state-label">
                                                        Training Proposal State
                                                    </InputLabel>
                                                    <Select
                                                        labelId="proposal-state-label"
                                                        label="Training Proposal State"
                                                        // fullWidth
                                                        onChange={(e) => setProposalState(e.target.value)}
                                                        value={proposalState}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="Confirmed">Confirmed</MenuItem>
                                                        <MenuItem value="Biding">Biding</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="training-type-label">Training Type</InputLabel>
                                                    <Select
                                                        labelId="training-type-label"
                                                        label="Training Type"
                                                        // fullWidth
                                                        onChange={(e) => setTrainingType(e.target.value)}
                                                        value={trainingType}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="Corporate">Corporate</MenuItem>
                                                        <MenuItem value="Individual">Individual</MenuItem>
                                                        <MenuItem value="Public Batch">Public Batch</MenuItem>
                                                        <MenuItem value="College Seminars">College Seminars</MenuItem>
                                                        <MenuItem value="Public Seminars">Public Seminars</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="training-timing-label">Training Timing</InputLabel>
                                                    <Select
                                                        labelId="training-timing-label"
                                                        label="Training Timing"
                                                        // fullWidth
                                                        onChange={(e) => setTrainingTiming(e.target.value)}
                                                        value={trainingTiming}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="4 hours">4 hours</MenuItem>
                                                        <MenuItem value="8 hours">8 hours</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="audience-level-label">
                                                        Audience Level
                                                    </InputLabel>
                                                    <Select
                                                        labelId="audience-level-label"
                                                        label="Audience Level"
                                                        fullWidth
                                                        onChange={(e) => setAudienceLevel(e.target.value)}
                                                        value={audienceLevel}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="Fresher">Fresher</MenuItem>
                                                        <MenuItem value="Lateral">Lateral</MenuItem>
                                                        <MenuItem value="Not Known">Not Known</MenuItem>
                                                        <MenuItem value="Mixed">Mixed</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel id="training-expectation-label">Training Expectation</InputLabel>
                                                    <Select
                                                        labelId="training-expectation-label"
                                                        label="Training Expectation"
                                                        // fullWidth
                                                        onChange={(e) => setTrainingExpectation(e.target.value)}
                                                        value={trainingExpectation}
                                                        style={{ minHeight: '44px' }}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="Beginners">Beginners</MenuItem>
                                                        <MenuItem value="Intermediate">Intermediate</MenuItem>
                                                        <MenuItem value="Expert">Expert</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <Autocomplete
                                                    // multiple
                                                    id="timeZone-autocomplete"
                                                    options={timeZones}
                                                    freeSolo
                                                    renderTags={(value, getTagProps) =>
                                                        value.map((option, tagIndex) => (
                                                            <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                                                                {option}
                                                            </span>
                                                        ))
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Working Time Zone"
                                                            variant="outlined"
                                                            style={{ minHeight: '40px', width: '290px' }}
                                                            fullWidth
                                                        />
                                                    )}
                                                    onChange={(_event, value) => handleTimeZoneChange(value)}
                                                />
                                            </div>
                                            <Typography style={{ marginLeft: '10px' }} variant="h6">Duration of Training (in hours)</Typography>
                                            <div style={{ marginTop: '10px', marginLeft: '10px', padding: '10px' }}>
                                                <Slider
                                                    value={durationSliderValue}
                                                    onChange={handleDurationSliderChange}
                                                    size="small"
                                                    getAriaValueText={valuetext}
                                                    valueLabelDisplay="auto"
                                                    aria-labelledby="range-slider"
                                                />
                                            </div>
                                            <div style={{ marginLeft: '10px', adding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <TextField
                                                    label="Min"
                                                    variant="outlined"
                                                    style={{ width: '100px' }}
                                                    // fullWidth
                                                    onChange={(e) => setFromDuration(e.target.value)}
                                                    value={fromDuration}
                                                    InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                    type="number"
                                                />
                                                <TextField
                                                    label="Max"
                                                    variant="outlined"
                                                    style={{ marginRight: '10px', width: '100px' }}
                                                    // fullWidth
                                                    onChange={(e) => setToDuration(e.target.value)}
                                                    value={toDuration}
                                                    InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                    type="number"
                                                />
                                            </div>
                                            <Typography style={{ marginLeft: '10px', marginRight: '20px', marginTop: '10px' }} variant="h6">Total Participants</Typography>
                                            <div style={{ marginLeft: '10px', marginTop: '10px', padding: '10px' }}>
                                                <Slider
                                                    value={participantsSliderValue}
                                                    onChange={handleSliderChange}
                                                    size="small"
                                                    getAriaValueText={valuetext}
                                                    valueLabelDisplay="auto"
                                                    aria-labelledby="range-slider"
                                                />
                                            </div>
                                            <div style={{ marginLeft: '10px', adding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <TextField
                                                    label="Min"
                                                    variant="outlined"
                                                    style={{ width: '100px' }}
                                                    // fullWidth
                                                    onChange={(e) => setMinParticipants(e.target.value)}
                                                    value={minParticipants}
                                                    InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                    type="number"
                                                />
                                                <TextField
                                                    label="Max"
                                                    variant="outlined"
                                                    style={{ marginRight: '10px', width: '100px' }}
                                                    // fullWidth
                                                    onChange={(e) => setMaxParticipants(e.target.value)}
                                                    value={maxParticipants}
                                                    InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                    type="number"
                                                />
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>

                                            </div>
                                            <Typography style={{ marginLeft: '10px', marginTop: '-10px', marginRight: '20px' }} variant="h6">Expected Start Date</Typography>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex' }}>
                                                <div>
                                                    <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>From Date</InputLabel>
                                                </div>
                                                <MKInput
                                                    type="date"
                                                    id="from_date"
                                                    value={fromDate || ""}
                                                    onChange={handleFromDateChange}
                                                    style={{ minHeight: '44px', width: '300px', marginLeft: '-80px' }}
                                                    placeholder="From Date"
                                                />
                                            </div>
                                            <div style={{ marginTop: '10px', padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                <div>
                                                    <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>To Date</InputLabel>
                                                </div>
                                                <MKInput
                                                    type="date"
                                                    id="to_date"
                                                    value={toDate || ""}
                                                    onChange={handleToDateChange}
                                                    style={{ minHeight: '44px', width: '300px', marginLeft: '-60px' }}
                                                    placeholder="To Date"
                                                />
                                            </div>

                                        </div>
                                    </Grid>

                                    <Grid item xs={8}>
                                        <Grid container style={{ marginTop: '10px', marginBottom: '10px' }} spacing={2}>
                                            <Grid item xs={12} sm={3}>
                                                <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h6" color="dark">
                                                    {filterTrainingList() ? `${filterTrainingList().length} result${filterTrainingList().length !== 1 ? 's' : ''} found` : 'Default Training Name'}
                                                </MKTypography>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <div>
                                                <>
                                                    {maxApplyCount ? (
                                                        <MKAlert color="error" dismissible >
                                                            You've reached the daily apply limit !
                                                        </MKAlert>
                                                    ) : (
                                                        ""
                                                    )}
                                                </>
                                            </div>
                                        </Grid>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            {getCurrentPageData().map((training, index) => (
                                                <Grid item xs={8} key={training.id} className="gridItemTrainingList" style={{ marginBottom: '20px' }}>
                                                    <div className="gridContent">
                                                        <div className="trainingInfo">
                                                            <Typography variant="subtitle1" className="trainingNameActive" ><strong>{training.trainingName}</strong></Typography>
                                                            <Typography style={{ fontSize: 'medium' }}>
                                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.displaySkills}
                                                                </span>
                                                            </Typography>
                                                            <Typography style={{ fontSize: 'medium' }}>
                                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                                                                    {training.trainingCompanyName}&nbsp;|

                                                                    {training.trainingMode === 'Virtual' && (
                                                                        <img src={VirtualIcon} alt="Virtual Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                                                                    )}

                                                                    {training.trainingMode === 'Classroom' && (
                                                                        <img src={ClassroomIcon} alt="Classroom Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                                                                    )} {training.trainingMode}

                                                                    {training.trainingMode === 'Classroom' && (
                                                                        <>
                                                                            {' | '}
                                                                            <LocationOn style={{ marginRight: '5px' }} />
                                                                            {training.trainingLocations}
                                                                        </>
                                                                    )}
                                                                </span>
                                                            </Typography>
                                                            <Typography style={{ fontSize: 'medium' }}>
                                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                    {training.currency}&nbsp;{training.totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
                                                                </span>
                                                            </Typography>
                                                            <Typography style={{ fontSize: 'medium' }}>
                                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training.expectedStartDate}
                                                                </span>
                                                            </Typography>
                                                        </div>
                                                        {localStorage.getItem("userId") ? (
                                                            <div>
                                                                <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                                                    <MKButton variant="gradient" color="info" size="small" onClick={() => onMoreDetailsClick(training)} style={{ padding: '5px 10px' }}>
                                                                        Details
                                                                    </MKButton>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                                                    <MKButton variant="gradient" color="info" size="small" onClick={() => onApplyClick(training)} style={{ padding: '5px 10px' }}>
                                                                        Apply
                                                                    </MKButton>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-50px' }}>
                                                                <MKButton variant="gradient" color="info" size="small" onClick={() => onMoreDetailsClick(training)} style={{ padding: '5px 10px' }}>
                                                                    Details
                                                                </MKButton>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Grid>
                                            ))}
                                            <div style={{ marginTop: '10px', marginLeft: '-280px', display: 'flex', justifyContent: 'center' }}>
                                                <MKButton onClick={handlePrevClick} color="info" variant="gradient" size="small" disabled={currentPage === 1}>
                                                    <Icon>keyboard_arrow_left</Icon>
                                                </MKButton>
                                                {Array.from({ length: currentTotalPages }).map((_, index) => (
                                                    <MKButton
                                                        key={index}
                                                        onClick={() => setCurrentPage(index + 1)}
                                                        variant={currentPage === index + 1 ? 'gradient' : 'gradient'}
                                                        color="info"
                                                        size="small"
                                                    >
                                                        {index + 1}
                                                    </MKButton>
                                                ))}
                                                <MKButton onClick={handleNextClick} variant="gradient" color="info" size="small" disabled={currentPage === totalPages}>
                                                    <Icon>keyboard_arrow_right</Icon>
                                                </MKButton>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Container>
                        </form>
                    </Container>
                </Card>
                <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
                        <SimpleFooter />
                    </MKBox>
                </div>
            </LoadingOverlay>
        </>
    );
}

export default Page;